import { render, staticRenderFns } from "./system_management_position.vue?vue&type=template&id=784bb1e0&scoped=true"
import script from "./system_management_position.vue?vue&type=script&lang=js"
export * from "./system_management_position.vue?vue&type=script&lang=js"
import style0 from "./system_management_position.vue?vue&type=style&index=0&id=784bb1e0&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "784bb1e0",
  null
  
)

export default component.exports